import PriceDisplay from '@/components/PriceDisplay';
import type { BookedAncillaryDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { Checkbox, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface AncillarySelectionCardProps {
  ancillary: BookedAncillaryDTO;
  passengerName: string;
  isChecked: boolean;
  onToggle: () => void;
}

export const AncillarySelectionCard: FC<AncillarySelectionCardProps> = ({
  ancillary,
  passengerName,
  isChecked,
  onToggle,
}) => (
  <div
    className={cn(
      'cursor-pointer rounded-sm border border-neutral-light px-3 py-1.5 focus-within:outline-none focus-within:ring-2 focus-within:ring-tint focus-within:ring-offset-2 hover:border-primary-medium hover:bg-primary-pale',
      {
        'border-primary bg-primary-light': isChecked,
      }
    )}
    onClick={onToggle}
    data-state={isChecked ? 'checked' : 'unchecked'}
  >
    <div className="flex items-center gap-3">
      <div onClick={(event) => event.stopPropagation()}>
        <Checkbox isSelected={isChecked} onChange={onToggle} />
      </div>
      <div className="flex w-full flex-row items-center justify-between py-0.5">
        <div className="flex flex-col items-start justify-between gap-0.5">
          <div className="flex items-center gap-2">
            <Typography variant="body2-bold">
              {ancillary.productDescription || ancillary.productSummary}
            </Typography>
          </div>
          <Typography variant="body2" className="text-neutral">
            {passengerName}
          </Typography>
        </div>
        <Typography variant="body2-bold" className="text-primary">
          <PriceDisplay amount={ancillary.price?.amount} />
        </Typography>
      </div>
    </div>
  </div>
);
